var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3807",
    "data-name": "Rectangle 3807",
    width: 32,
    height: 32,
    transform: "translate(332 4128)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_613",
    "data-name": "Mask Group 613",
    transform: "translate(-332 -4128)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PDF_Doc",
    "data-name": "PDF Doc",
    transform: "translate(334.128 4128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M24.061,8.035a3.347,3.347,0,0,0-.131-.924,3.292,3.292,0,0,0-.84-1.416L18.427,1.032A3.506,3.506,0,0,0,15.93,0h-.842L10.2.014H8.7L7.477,0C5.188,0,3.33.085,1.992,1.158S.11,3.92,0,7.105V24.388c0,3.525.628,5.409,2.164,6.5C3.625,31.923,5.67,32,8.619,32H15.45c2.949,0,4.99-.077,6.452-1.114,1.536-1.1,2.162-2.974,2.162-6.5V8.032",
    fill: "#3bc1d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M35.693,1.339A3.547,3.547,0,0,0,34.623.6h-.091V1.865c0,2.357.2,3.89,1.24,4.758.941.787,2.279.787,4.313.787h1.1a3.292,3.292,0,0,0-.84-1.416Z",
    transform: "translate(-17.266 -0.302)",
    fill: "#85d8e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M12.029.014H8.7L7.477,0C5.188,0,3.33.085,1.992,1.158S.11,3.92,0,7.105V24.388c0,3.525.628,5.409,2.164,6.5a5.47,5.47,0,0,0,2.225.872Z",
    fill: "#359ebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M12.246,13.963H7.607a.519.519,0,1,1,0-1.037h4.639a.519.519,0,1,1,0,1.037",
    transform: "translate(-3.544 -6.463)",
    fill: "#d91a32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M23.507,19.356H7.573a.519.519,0,1,1,0-1.037H23.507a.519.519,0,0,1,0,1.037m0,2.7H7.573a.518.518,0,1,1,0-1.034H23.507a.518.518,0,1,1,0,1.034",
    transform: "translate(-3.51 -9.159)",
    fill: "#e2ded6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4988",
    "data-name": "Group 4988",
    transform: "translate(11.957 18.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M2.832,0H12.955a2.832,2.832,0,0,1,2.832,2.832V6.01a2.832,2.832,0,0,1-2.832,2.832H2.832A2.832,2.832,0,0,1,0,6.01V2.832A2.832,2.832,0,0,1,2.832,0Z",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "label",
    d: "M3.9-7.116v-.051c0-1.065-.844-1.365-1.7-1.365a8.341,8.341,0,0,0-1.15.074c-.176.028-.255.079-.255.272v3.807A.109.109,0,0,0,.827-4.3a.109.109,0,0,0,.079.03h.731a.113.113,0,0,0,.113-.113V-5.762c.142.006.323.017.459.017C3.053-5.745,3.9-6.056,3.9-7.116Zm-.963,0c0,.385-.221.572-.725.572-.062,0-.4-.006-.459-.011V-7.71c.068-.006.38-.017.459-.017.476,0,.725.159.725.561Zm4.724,1.1v-.731a1.621,1.621,0,0,0-.47-1.333,1.621,1.621,0,0,0-1.337-.457,8.5,8.5,0,0,0-1.207.085.17.17,0,0,0-.128.061.17.17,0,0,0-.037.137V-4.5a.17.17,0,0,0,.037.137.17.17,0,0,0,.128.061,8.5,8.5,0,0,0,1.207.085,1.621,1.621,0,0,0,1.337-.457,1.621,1.621,0,0,0,.47-1.333Zm-.969,0c0,.765-.329.969-.838.969-.142,0-.323-.006-.4-.011V-7.7c.079-.006.261-.011.4-.011.51,0,.838.2.838.969Zm4.226-1.8v-.527c0-.074-.034-.1-.113-.113a6.589,6.589,0,0,0-1.093-.074c-.731,0-1.382.181-1.382,1.212v2.929a.113.113,0,0,0,.113.113h.736a.113.113,0,0,0,.113-.113V-6.039h1.467a.113.113,0,0,0,.113-.113v-.538a.113.113,0,0,0-.113-.113H9.29v-.51c0-.295.1-.385.363-.385H10.8a.113.113,0,0,0,.113-.113Z",
    transform: "translate(2.039 10.798)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.ec4f2edaf6dd117b0a70bafd6514897b.svg";
export { ForwardRef as ReactComponent };